export const RATE_LIMIT_MESSAGE = "Estás enviando demasiadas solicitudes. Por favor, espera un momento y vuelve a intentarlo.";
export const CONNECTION_MESSAGE = "No hemos podido conectar. Comprueba tu conexión e inténtalo de nuevo.";

/** Never show HTTP codes, proxy HTML, database exceptions or SDK messages. */
export function apiErrorMessage(status: number, body: unknown, fallback?: string): string {
  if (status === 429) return RATE_LIMIT_MESSAGE;
  if (status === 401) return fallback ?? "Tu sesión ha caducado. Vuelve a iniciar sesión para continuar.";
  if (status === 408 || status === 504) return "La solicitud está tardando más de lo esperado. Inténtalo de nuevo.";
  if (status >= 500) return "Ahora no podemos completar la solicitud. Por favor, inténtalo de nuevo más tarde.";
  const payload = body && typeof body === "object" ? body as { error?: unknown; message?: unknown } : null;
  const supplied = typeof payload?.error === "string" ? payload.error : typeof payload?.message === "string" ? payload.message : "";
  const technical = /request failed|status\s*\d{3}|SQLITE|constraint failed|TypeError|SyntaxError|stack trace|<\/?(?:html|body|script)|\bat\s+\S+\.(?:ts|js):\d/i;
  const spanish = /[áéíóúñ¿¡]|\b(?:cuenta|correo|solicitud|nombre|equipo|miembro|datos|acceso|debes|puedes|confirma|escribe|antes de|no se|no hay)\b/i;
  if (supplied.length <= 400 && !technical.test(supplied) && spanish.test(supplied)) return supplied;
  if (status === 403) return "No tienes permiso para realizar esta acción.";
  if (status === 404) return "No hemos encontrado lo que buscas. Puede que ya no esté disponible.";
  if (status === 413) return "El contenido es demasiado largo. Redúcelo un poco e inténtalo de nuevo.";
  if (status === 400 || status === 422) return fallback ?? "Revisa los datos e inténtalo de nuevo.";
  if (status === 409) return "No hemos podido completar este cambio. Revisa los datos e inténtalo de nuevo.";
  return fallback ?? "No hemos podido completar la solicitud. Inténtalo de nuevo.";
}

export function retryAfterSeconds(header: string | null, now = Date.now()): number | undefined {
  if (!header?.trim()) return undefined;
  const seconds = /^\d+$/.test(header.trim()) ? Number(header) : Math.ceil((Date.parse(header) - now) / 1000);
  return Number.isFinite(seconds) ? Math.max(1, Math.min(86400, seconds)) : undefined;
}

export function authErrorMessage(error: { status?: number; code?: string; message?: string }, fallback: string): string {
  if (error.status === 0) return CONNECTION_MESSAGE;
  if (error.status === 429 || error.code === "RATE_LIMIT_EXCEEDED" || error.code === "TOO_MANY_REQUESTS") return RATE_LIMIT_MESSAGE;
  const messages: Record<string,string> = {
    INVALID_EMAIL_OR_PASSWORD: "El correo o la contraseña no son correctos.",
    INVALID_PASSWORD: "La contraseña no es correcta.",
    INVALID_EMAIL: "Revisa la dirección de correo electrónico.",
    USER_ALREADY_EXISTS: "Ya existe una cuenta con ese correo. Prueba a iniciar sesión.",
    USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: "Ya existe una cuenta con ese correo. Prueba a iniciar sesión.",
    PASSWORD_TOO_SHORT: "La contraseña es demasiado corta. Añade más caracteres.",
    PASSWORD_TOO_LONG: "La contraseña es demasiado larga. Usa menos caracteres.",
  };
  const known = Object.hasOwn(messages,error.code ?? "") ? messages[error.code!] : undefined;
  return known ?? apiErrorMessage(error.status ?? 400,{message:error.message},fallback);
}
